<template>
  <div>
    <b-form @submit.prevent="submit">
      <b-form-group>
        <requiredComponent
          slot="label"
          :label="$lang.category_name"
          :rules="$v.category_name.$params"
        />
        <selectFind
          :options="enumOptions"
          v-model="$v.category_name.$model"
          label="text"
          id="value"
          :isValid="$v.category_name.$dirty ? !$v.category_name.$error : null"
          :disabled="mode === 'EDIT'"
        />
        <b-form-invalid-feedback
          :state="$v.category_name.$dirty ? !$v.category_name.$error : null"
        >
          <div v-if="!$v.category_name.required">
            {{ $lang.error_required | replace($lang.category_name) }}
          </div>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        :label="$lang.caption"
        label-for="enum_caption"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.caption"
          :rules="$v.enum_caption.$params"
        />
        <b-form-input
          id="enum_caption"
          type="text"
          :autocomplete="$lang.enum_caption"
          v-model="$v.enum_caption.$model"
          :state="$v.enum_caption.$dirty ? !$v.enum_caption.$error : null"
        >
        </b-form-input>

        <b-form-invalid-feedback id="caption-feedback"
          >{{ $lang.error_required | replace($lang.caption) }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        v-if="mode === 'EDIT'"
        :label="$lang.status"
        :label-cols="4"
      >
        <requiredComponent
          slot="label"
          :label="$lang.status"
          :rules="$v.is_enable.$params"
        />
        <b-form-checkbox
          v-model="$v.is_enable.$model"
          name="is-enable"
          class="mt-2"
          switch
        >
          <b v-if="$v.is_enable.$model" v-text="'فعال'" class="text-success" />
          <b v-else v-text="'غیرفعال'" class="text-danger" />
        </b-form-checkbox>
      </b-form-group>
      <b-form-group :label="$lang.is_default_value" :label-cols="4">
        <b-form-checkbox
          v-model="isDefault"
          name="is-default"
          class="mt-2"
          switch
          :value="true"
          :unchecked-value="false"
        />
      </b-form-group>
      <div slot="footer" class="form-group form-btn">
        <b-button class="mr-2" variant="outline-danger" @click="close">
          <mdicon name="close" size="24" />
          {{ $lang.cancelButton }}
        </b-button>
        <b-button v-if="isAdmin(permissions)" type="submit" variant="success">
          <mdicon name="check" size="24" />
          {{ $lang.submitButton }}
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { isAdmin } from "@/shared/utils";

export default {
  props: {
    mode: {
      type: String,
      default: "ADD",
    },
    permissions: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: null,
    },
  },
  validations: {
    category_name: {
      required: requiredIf((vm) => vm.mode === "ADD"),
    },
    enum_caption: {
      required,
    },
    is_enable: {},
    isDefault: {},
  },
  computed: {
    enumOptions() {
      let enumerations = JSON.parse(localStorage.getItem("enumerations") || []);
      enumerations = enumerations.filter((item) =>
        pathOr(false, ["is_editable"], item)
      );
      return enumerations.map((item) => {
        return {
          text: item.category_caption,
          value: item.category_name,
        };
      });
    },
  },
  data() {
    return {
      category_name: null,
      enum_caption: null,
      is_enable: false,
      isDefault: false,
    };
  },
  watch: {
    item: {
      immediate: true,
      handler() {
        this.fetchData();
      },
    },
  },
  methods: {
    pathOr,
    isAdmin,
    close() {
      this.$emit("close");
    },
    fetchData() {
      this.category_name = this.enumOptions.find(
        (item) => item.value === pathOr(null, ["category_name"], this.item)
      );
      this.enum_caption = pathOr(null, ["enum_caption"], this.item);
      this.is_enable = !!pathOr(0, ["is_enable"], this.item);
      this.isDefault = pathOr(false, ["is_default"], this.item);
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      const payload = {
        category_name: pathOr(null, ["value"], this.category_name),
        enum_caption: this.enum_caption,
        is_enable: +this.is_enable,
        is_default: +this.isDefault,
      };

      this.$emit("submit", payload);
    },
  },
};
</script>
